export default __webpack_public_path__ + "static/media/handspaper.68c69b50.png";